// المشاريع الموثّقة الحديثة من عرض «مشاريع سياق»، مرتبة حسب ظهورها.
export const PROJECTS = [
  {
    slug: "haramain-volunteer-sustainability",
    title: "بناء منهجية استدامة مركز الحرمين التطوعي",
    pathSlug: "guests-of-rahman",
    excerpt:
      "تمكين مركز الحرمين التطوعي من بناء ممارسات متكاملة للاستثمار الأمثل للموارد المتاحة لخدمة ضيوف الرحمن.",
    body:
      "أدوات وتطبيقات عملية ومؤشرات أداء لمختلف مجالات الاستدامة تضمن تحقيق بيئة تطوع نوعية وتعظيم أثر تجربة خدمة ضيوف الرحمن، مع تحديد أصحاب العلاقة وتحليل توقعاتهم، وبناء نموذج عمل استدامة المركز ومقاره الثابتة والمتنقلة، وخارطة تنفيذ وإجراءات تقييم واضحة.",
  },
  {
    slug: "moewa-npo-strategy",
    title: "بناء استراتيجية الإدارة العامة لمنظمات القطاع غير الربحي بوزارة البيئة والمياه والزراعة",
    pathSlug: "community-development",
    excerpt:
      "بناء التوجهات الاستراتيجية للإدارة عبر فهم الواقع والاحتياجات وإشراك أصحاب المصلحة المؤثرين والمتأثرين.",
    body:
      "شمل المشروع تقييم الوضع الراهن للإدارة العامة ولإدارتَي التأسيس والإشراف والمتابعة، وبناء استراتيجية شاملة، وابتكار مبادرات لتشجيع تأسيس منظمات غير ربحية ضمن مجالات الوزارة، إضافة إلى نماذج تشغيل وحوكمة، وتطوير خطط المسؤولية الاجتماعية وحث القطاع الخاص على المساهمة في الفرص التنموية.",
  },
  {
    slug: "waqf-volunteering-strategy",
    title: "استراتيجية التطوع الوقفي",
    pathSlug: "community-participation",
    excerpt:
      "بناء استراتيجية وتنظيمات داعمة للتطوع الوقفي تعزّز ثقافته وتمكّن المؤسسات الوقفية من تفعيله ضمن منظومة نموذجية.",
    body:
      "دراسة أفضل الممارسات وتحليل الوثائق وتحديد احتياجات التطوع الوقفي، ثم بناء التوجهات الاستراتيجية والهيكل التنظيمي، وإعداد دليل أصحاب المصلحة، ودليل الحوكمة، والدليل التشغيلي، ودليل المبادرات، ومنهجية الشراكات لقطاع التطوع الوقفي.",
  },
  {
    slug: "manual-carts-system",
    title: "تطوير وتنظيم منظومة العربات اليدوية في المسجد الحرام",
    pathSlug: "guests-of-rahman",
    excerpt:
      "تنظيم دفع العربات اليدوية لتحسين تجربة المعتمرين وكبار السن وذوي الإعاقة، وتمكين الدفافين ضمن مظلة نظامية.",
    body:
      "تصميم حقائب تدريبية وتأهيل ٦٬٠٠٠ دافع و٢٣٢ مشرفًا ومراقبًا، وتصميم الهوية البصرية للدفافين، وبناء الاستراتيجية الاتصالية للمنظومة، وتصميم شكل العربة، وبناء النظام المالي (أودو) وأتمتة العمليات، وقياس رحلة وتجربة المشروع.",
  },
  {
    slug: "housing-associations-institutionalization",
    title: "مأسسة الجمعيات الإسكانية",
    pathSlug: "community-development",
    excerpt:
      "بناء القدرات المؤسسية لثلاث جمعيات إسكانية ناشئة في مناطق مختلفة من المملكة.",
    body:
      "ركّز المشروع على تأسيس الممارسات والقدرات المؤسسية التي تمكّن الجمعيات الإسكانية الناشئة من أداء أدوارها بكفاءة واستدامة في ثلاث مناطق مستهدفة.",
  },
  {
    slug: "hajj-sports-services-1446",
    title: "إعداد وتصميم وتنفيذ خدمات وزارة الرياضة لموسم حج 1446هـ",
    pathSlug: "guests-of-rahman",
    excerpt:
      "خدمات لوجستية ورياضية لضيوف الرحمن شملت المتطوعين والأركان الرياضية والحملات الإعلامية والتوثيق الشامل.",
    body:
      "توفير خدمات لوجستية وإسكانية لحجاج وزارة الرياضة والمتطوعين من المنافذ إلى المشاعر، و٥ بوثات صحية، والزي والتوزيعات للمتطوعين، وتصميم وإطلاق ٨ حملات إعلانية، وخدمة حج ٣٠ ضيفًا من الفئة (أ)، مع إعداد تقرير شامل للمشروع.",
  },
  {
    slug: "edama-volunteering-accelerator",
    title: "مسرعة العمل التطوعي «مسرعة إدامة»",
    pathSlug: "community-participation",
    excerpt:
      "منهجية مبتكرة تدمج المعيار الوطني للعمل التطوعي «إدامة» مع أسلوب مسرعات الأعمال لتسريع مأسسة وحدات التطوع.",
    body:
      "بناء منهجية المسرعة وأدلتها وأدواتها ونماذجها، وتشغيل ٤ دفعات بواقع ٢٥ جهة لكل دفعة، مع تقييم الواقع وموائمة الأدلة والمواثيق، وتمكين قدرات مدراء التطوع، والإطلاق التفعيلي لوحدات العمل التطوعي، وتقييم أدائها خلال فترة التفعيل.",
  },
  {
    slug: "emad-executive-directors",
    title: "عِماد: بناء وتطوير قدرات المديرين التنفيذيين في الجمعيات الأهلية",
    pathSlug: "community-development",
    excerpt:
      "منهجية متخصصة لاستقطاب وتمكين قدرات المشاركين لوظيفة الإدارة التنفيذية في الجمعيات الأهلية.",
    body:
      "خارطة تمكين واختيار المستهدفين، وإجراء مقياس جالوب واختبار هولاند، وجلسات كوتشنج مهنية عن نقاط القوة، وتأهيل على مسارات تمكين المدراء، وبناء خارطة تطبيق عملي لأدوات الإدارة التنفيذية، وبرامج إثرائية، وتقييمات أداء دورية، والترويج للمدراء عبر منصة متخصصة.",
  },
  {
    slug: "carts-experience-index",
    title: "قياس تجربة منظومة دفع العربات اليدوية في المسجد الحرام",
    pathSlug: "guests-of-rahman",
    excerpt:
      "إطار مؤشر لتجربة ضيوف الرحمن يقيس أربعة أبعاد: الشعائر والتفاعل وبيئة العمل والمكان.",
    body:
      "اعتمد القياس على مؤشرات CSAT وNPS وNSI وCES، وشمل استبيانات المعتمرين ومقدمي الخدمة، ومقابلات ميدانية، وملاحظات مباشرة، وتحليلًا كميًا ونوعيًا لرصد الأداء والتحديات وفرص التحسين، مع رسم رحلة ضيف الرحمن ورحلة الدفافين، وتقديم توصيات تطويرية على مستوى الحوكمة والموارد البشرية والمسارات والأنظمة الرقمية.",
  },
  {
    slug: "social-impact-sroi",
    title: "قياس الأثر الاجتماعي وفق منهجية SROI",
    pathSlug: "social-investment",
    excerpt:
      "دراسة متكاملة لقياس الأثر الاجتماعي وإصدار تقرير القياس للمشروع المستهدف.",
    body:
      "تقرير قياس الأثر المجتمعي لجمعية هدية، وتأهيل وتدريب فريق العمل على منهجية العائد الاجتماعي على الاستثمار SROI، والإشراف والمتابعة على تطبيق المنهجية.",
  },
  {
    slug: "csr-strategy",
    title: "بناء استراتيجية المسؤولية الاجتماعية CSR",
    pathSlug: "social-responsibility",
    excerpt:
      "استراتيجية شاملة لتفعيل المسؤولية الاجتماعية في الشركة عبر إشراك موظفيها والقطاع غير الربحي.",
    body:
      "تحديد توقعات صناع القرار، وتحليل مكتبي للوثائق والتشريعات، ورصد التجارب المحلية والعالمية، وبناء التوجهات الاستراتيجية (الرؤية والرسالة والقيم والأهداف والمبادرات والمؤشرات) للمسؤولية الاجتماعية للشركة المتقدمة.",
  },
  {
    slug: "social-investment-incubator",
    title: "حاضنة مشاريع الاستثمار الاجتماعي للجمعيات",
    pathSlug: "social-investment",
    excerpt:
      "برنامج متكامل لتمكين ٢٦ جهة غير ربحية من أدوات الاستثمار الاجتماعي وإعداد مشاريعها الاستثمارية.",
    body:
      "توعية وتثقيف حول مفاهيم الاستثمار الاجتماعي، وتحديد قضية الاحتياج وتصميم فكرة المشروع لكل جهة، وتأهيلها على دراسة الجدوى بأبعادها التسويقية والفنية والإدارية والمالية، وإعداد مشاريع مكتملة جاهزة للدعم والتمويل، ومتابعة تطبيق الأدوات، وتنظيم معرض للربط بين الممولين والجهات العارضة.",
  },
  {
    slug: "health-volunteering-incentives",
    title: "منظومة محفزات التطوع الصحي",
    pathSlug: "community-participation",
    excerpt:
      "منظومة تحفيز وتكريم متكاملة ومحكومة تنظّم وتقود القطاع الصحي وتحفّزه على العطاء المستمر.",
    body:
      "تحليل الأنظمة والتشريعات ذات العلاقة، ورصد توقعات المتطوعين، ومقارنة معيارية عالمية، ودراسة خيارات التحفيز واستدامتها، وبناء اللائحة التنظيمية لتحفيز وتكريم المتطوعين الصحيين، ونماذج تحفيز القطاع العام وغير الربحي، ومنهجية قياس تأثير التحفيز، وخارطة تفعيل شركاء القطاع الخاص.",
  },
  {
    slug: "social-innovation-lab",
    title: "تأسيس معمل الابتكار الاجتماعي",
    pathSlug: "social-innovation",
    excerpt:
      "معمل داخل الجمعية يشجّع على تطوير وتنفيذ أفكار مبتكرة لحل التحديات المرتبطة بضيوف الرحمن.",
    body:
      "بناء نموذج عمل المعمل، ومنهجية تحديد التحديات الاجتماعية لضيوف الرحمن، ومنهجية تصميم الحلول المبتكرة، ومصفوفة أصحاب المصلحة، والأدلة التنظيمية والتشغيلية، والتوجه الاستراتيجي للمعمل، وخارطة قياس أثره.",
  },
  {
    slug: "hajj-challenge-products",
    title: "ابتكار منتجات لتحديات موسم الحج",
    pathSlug: "guests-of-rahman",
    excerpt:
      "تصميم حلول مبتكرة لبعض قضايا ضيوف الرحمن بهدف تحسين تجربة رحلة الحاج أثناء الموسم.",
    body:
      "تحديد وتحليل قضايا وتحديات ضيوف الرحمن، وتصميم الحلول المبتكرة، وتصميم الحد الأدنى للحل المبتكر (نموذج MVP)، وتجربة وتقييم الحل المبتكر وتطويره وتحسينه.",
  },
  {
    slug: "social-investment-capability-assessment",
    title: "تقييم القدرات المؤسسية في الاستثمار الاجتماعي والاستدامة",
    pathSlug: "social-investment",
    excerpt:
      "تقييم قدرة الجمعية في الاستثمار الاجتماعي وأدوات الاستدامة وتحديد الفجوات ذات الأولوية.",
    body:
      "تقييم واقع الجمعية في مسار الاستثمار الاجتماعي والاستدامة، وإعداد تقرير تفصيلي، وتطوير نموذج عمل الجمعية وفق ممارسات الاستثمار الاجتماعي، وبناء نظرية التغيير المجتمعي الخاصة بها.",
  },
  {
    slug: "youth-identity-priorities",
    title: "دراسة أولويات القضايا التي تمس هوية الشباب",
    pathSlug: "community-development",
    excerpt:
      "تحديد أولويات القضايا التي تمس هوية الشباب وتصميم أبرز الحلول والتدخلات التي تعزّز القيم الإيجابية والهوية الوطنية.",
    body:
      "توصيف قضية الدراسة ومحاورها، ومسح مكتبي مفاهيمي تفصيلي، وتحديد أصحاب العلاقة وتحليل بياناتهم، وتقارير عن أفضل الممارسات المحلية والعالمية، وبناء نظرية التغيير المجتمعي، وتصميم ٤–٥ حلول بمنهجية Design Thinking للقضايا ذات الأولوية.",
  },
  {
    slug: "nonprofit-strategic-planning",
    title: "تأهيل قيادات القطاع غير الربحي على التخطيط الاستراتيجي والتشغيلي",
    pathSlug: "community-development",
    excerpt:
      "تأهيل نوعي ومكثف لعشرين قائدًا وقائدة بأسلوب عملي على أدوات ومنهجيات التخطيط الاستراتيجي والتشغيلي.",
    body:
      "تمكين القيادات في المنظمات غير الربحية بمنطقة جازان على أدوات التخطيط الاستراتيجي والتشغيلي، بدءًا من المفاهيم والمصطلحات، مرورًا بالمنهجيات، وصولًا إلى تطبيق الأدوات لبناء الخطط ودمج الاستراتيجي بالتشغيلي.",
  },
  {
    slug: "community-initiatives-design",
    title: "تصميم المبادرات المجتمعية",
    pathSlug: "community-development",
    excerpt:
      "تمكين ٨ منظمات غير ربحية من أدوات تصميم المبادرات المجتمعية من تحديد الاحتياجات إلى إعداد الوثيقة التفصيلية.",
    body:
      "تحديد ووصف القضايا والاحتياجات المجتمعية الملحّة، وتأهيل ٣٠ مشاركًا ومشاركة على خطوات تصميم المبادرات وتطبيقها، وتوفير ٥ موجهين ومستشارين، وإقامة مخيم تطويري لتحسين الأفكار، وتدريب الجهات على إعداد وثيقة المبادرة.",
  },
  {
    slug: "volunteering-managers-capabilities",
    title: "بناء قدرات مدراء وحدات العمل التطوعي",
    pathSlug: "community-participation",
    excerpt:
      "تحديد الاحتياجات والفجوات في بيئة عمل قيادات قطاع العمل التطوعي وتصميم تدخلات نوعية لتطوير بيئتهم.",
    body:
      "تقييم واقع القطاع، وتصميم تدخلات تطوير قدرات مدراء الوحدات، وتنفيذ مقياس Clifton Strengths وجلسات كوتشنج نقاط القوة، وتمكين المدراء من أدوات القيادة وفق منهجية LMI ومن أدوات الابتكار في تصميم المبادرات.",
  },
  {
    slug: "organization-strategic-plan",
    title: "بناء الخطة الاستراتيجية للمنظمة",
    pathSlug: "community-development",
    excerpt:
      "بناء التوجهات الاستراتيجية للمنظمة عبر فهم الواقع والاحتياجات وإشراك أصحاب المصلحة.",
    body:
      "وصف وتحديد القضية الرئيسية، وتحليل تطلعات أصحاب المصلحة، ومستند الأنظمة والتشريعات والتوجهات الوطنية ذات العلاقة، ووثيقة تحليل البيانات، وبناء التوجهات الاستراتيجية، ووثيقة المؤشرات والمبادرات، والخطة التنفيذية للاستراتيجية.",
  },
  {
    slug: "corporate-volunteering-unit",
    title: "تأسيس وحدة المشاركة التطوعية في القطاع الخاص",
    pathSlug: "social-responsibility",
    excerpt:
      "إنشاء وتفعيل وحدة إدارية متكاملة داخل الشركة تُعنى بتنظيم مشاركة الموظفين في العمل التطوعي المؤسسي.",
    body:
      "بناء السياسات والهياكل والنماذج التشغيلية للوحدة، وربط قدرات الموظفين باحتياجات المجتمع، وفق أفضل الممارسات المحلية والعالمية، مع خارطة تنظيمية وتشغيلية، وأدوات ونماذج تنفيذية، وخطة تشغيل معتمدة، وتقرير ختامي للتأسيس.",
  },
  {
    slug: "mobile-innovation-lab",
    title: "معمل الابتكار المتنقل",
    pathSlug: "social-innovation",
    excerpt:
      "منهجية «ابتكار مفتوح» قائمة على المشاركة المجتمعية لتصميم واختبار نماذج حلول عملية ومستدامة.",
    body:
      "إشراك أصحاب المصلحة والمستفيدين في كافة مراحل الابتكار من فهم المشكلة إلى تصميم نماذج أولية Prototype، مع تجهيز وحدة المعمل المتنقل، وتنفيذ ١٢ ورشة ميدانية، ومشاركة ٣٠٠ محلي، وتطوير ٦٠ فكرة ومشروعًا أوليًا، واختيار ٢٠ مشروعًا للتوسيع، وخطط تنفيذية قابلة للتمويل، ومنصة إلكترونية للمشاريع.",
  },
  {
    slug: "young-leaders-enablement",
    title: "تمكين القيادات الشابة",
    pathSlug: "community-development",
    excerpt:
      "برنامج تنموي يحوّل المشاريع الأكاديمية لطلاب الجامعة إلى رحلة تطوير مهني هادفة تسد فجوات كفاءات القطاع.",
    body:
      "تشخيص الاحتياجات المهنية في الجمعيات، وتوجيه المشاريع التطبيقية الجامعية نحو هذه الفجوات، وتقييم فرد لكل طالب وإلحاقه بمسار تدريبي إلكتروني مصمَّم لضمان جاهزيته، مع منصة إلكترونية، وشراكات موقّعة، وتدريب ٥٠٠ طالب، وجلسات إرشاد منتظمة، وفرص توظيف عند الختام.",
  },
  {
    slug: "solidarity-volunteering",
    title: "التطوع التضامني",
    pathSlug: "community-participation",
    excerpt:
      "بناء نواة عمل منظمة في كل حي من أحياء مكة المكرمة يقودها السكان أنفسهم لنشر ثقافة العطاء.",
    body:
      "منظومة تمكّن أهالي الحي من إطلاق وتنفيذ فرص تطوعية نابعة منهم، بذروتها الرمزية في يوم التطوع السعودي والعالمي (٥ ديسمبر) ككرنفال للعطاء في كل حي مستهدف. شمل المشروع وثائق الحوكمة والفريق التنفيذي، والفرص التطوعية، والخطة التشغيلية، ومعايير تقييم الجودة، واستراتيجية الحشد والترويج، وتقارير القياس والدروس المستفادة.",
  },
  {
    slug: "volunteering-environments",
    title: "بيئات التطوع",
    pathSlug: "community-participation",
    excerpt:
      "مبادرة تنموية تهيّئ بيئات تطوعية فاعلة بقدرات مؤسسية وكفاءات قيادية قادرة على استقطاب المتطوعين وتحفيز مشاركتهم.",
    body:
      "ثلاثة مشاريع متكاملة: تمكين بيئات التطوع (تقييم مؤسسي لثلاث بيئات، خطط تطوير القدرات، وإغلاق الفجوات)، وتأهيل الكوادر التطوعية (خطة تأهيل معتمدة مع مؤشرات قياس)، والمبادرات التطوعية (اعتماد ٧٠ فرصة، وقاعدة بيانات للمتطوعين، وخطة استقطاب رقمية، ومشاركة مستهدفة ١٤٬٠٠٠ متطوع، مع قياس الأثر ومقاييس الرضا).",
  },
];
